// JSON-LD schema factory functions for SEOHead component

const ORG = {
  name: "Son's Guadalupe",
  url: "https://sonsguadalupe.com",
  logo: "https://sonsguadalupe.com/og-image.png",
  telephone: "+1-877-577-7667",
  email: "info@sonsgetaways.com",
  address: {
    "@type": "PostalAddress",
    addressLocality: "New Braunfels",
    addressRegion: "TX",
    addressCountry: "US",
  },
  sameAs: [] as string[],
};

export const localBusinessSchema = (overrides: Record<string, unknown> = {}) => ({
  "@context": "https://schema.org",
  "@type": "LodgingBusiness",
  ...ORG,
  priceRange: "$$",
  image: ORG.logo,
  ...overrides,
});

export const touristAttractionSchema = (
  name: string,
  description: string,
  image?: string,
) => ({
  "@context": "https://schema.org",
  "@type": "TouristAttraction",
  name,
  description,
  image: image || ORG.logo,
  address: ORG.address,
  url: ORG.url,
});

export const faqPageSchema = (faqs: { q: string; a: string }[]) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map(({ q, a }) => ({
    "@type": "Question",
    name: q,
    acceptedAnswer: { "@type": "Answer", text: a },
  })),
});

export const breadcrumbSchema = (items: { name: string; url: string }[]) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.name,
    item: item.url,
  })),
});

export const productSchema = (
  name: string,
  description: string,
  priceFrom: number,
  url: string,
  image?: string,
) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  name,
  description,
  image: image || ORG.logo,
  brand: { "@type": "Brand", name: ORG.name },
  offers: {
    "@type": "Offer",
    price: priceFrom,
    priceCurrency: "USD",
    availability: "https://schema.org/InStock",
    url,
  },
});
